import {useField} from 'formik';
import {isBoolean} from 'lodash';
import {useCallback, useMemo} from 'react';

import {Input, InputProps} from './Input';

type Props = {
    name: string;
} & Partial<InputProps>;

export const InputFormik: React.FC<Props> = ({name, required, hasError: hasErrorProp, ...rest}: Props) => {
    const [field, meta, helper] = useField(name);

    const hasError = useMemo<boolean>(
        () => {
            if (isBoolean(hasErrorProp)) {
                return hasErrorProp;
            }
            return meta.error && (meta.touched || meta.value) || meta.touched && required && !meta.value;
        },
        [meta, hasErrorProp, required]
    );

    const handleBlur = useCallback((e: React.FocusEvent) => {
        field.onBlur(e);
    }, [field]);

    const onChangeHandler = useCallback((value: string | number) => {
        helper.setValue(value);
    }, [helper]);

    return (
        <Input
            {...rest}
            name={name}
            value={field.value === null ? '' : field.value}
            required={required}
            hasError={hasError}
            errorMessage={meta.error}
            onBlur={handleBlur}
            onChange={onChangeHandler}
        />
    );
};